import React from 'react';
import { config } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles.css';

// Configure FontAwesome
config.autoAddCss = false;

interface StrictPropsProviderProps {
  children: React.ReactNode;
}

export const StrictPropsProvider = ({ children }: StrictPropsProviderProps) => {
  React.useEffect(() => {
    // Suppress FontAwesome defaultProps warning in development
    if (process.env.NODE_ENV === 'development') {
      const originalError = console.error;
      console.error = (...args: any[]) => {
        if (
          typeof args[0] === 'string' &&
          args[0].includes('FontAwesomeIcon: Support for defaultProps will be removed')
        ) {
          return;
        }
        originalError.call(console, ...args);
      };

      return () => {
        console.error = originalError;
      };
    }
  }, []);

  return <>{children}</>;
}; 